var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CDescriptionList',{attrs:{"title":_vm.$tc('order', 1)}},[_c('CDescriptionListItem',{attrs:{"label":_vm.$t('paymentStatus')}},[_c('PaymentStatus',{attrs:{"status":_vm.order.status}})],1),_vm._l((_vm.rows),function(ref){
var key = ref[0];
var value = ref[1];
var bold = ref[2];
return _c('CDescriptionListItem',{key:key,attrs:{"no-value-label":_vm.$t('noValue'),"label":_vm.$tc(key, 1),"value":value,"highlight":bold || false}})})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }